export default "__VITE_ASSET__022bd367__"